import isUndefined from 'lodash/isUndefined';

export default function combineProps(props = {}, defaultProps = {}) {
  return Object.entries({ ...defaultProps, ...props })
    .map(([key, value]) => (isUndefined(props[key]) ? [key, defaultProps[key]] : [key, value]))
    .reduce((o, [key, value]) => ({ ...o, [key]: value }), {});
}
